import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isVisible: false,
  type: 'auth',
  offerData: null,
  quantityPurchase: 1,
  isMobileFiltersOpened: false
}

export const popupsSlice = createSlice({
  name: 'popups',
  initialState,
  reducers: {
    setPopup: (state, action) => {
      if (action.payload !== 'close') {
        state.isVisible = true;
        state.type = action.payload.type;
        state.offerData = action.payload.offerData;

      } else if (action.payload === 'close') {
        state.isVisible = false
      }
    },
    changeQuantity: (state, action) => {
      state.quantityPurchase = action.payload

      if (action.payload < 1) {
        state.quantityPurchase = 1
      }
    },
    changeMobileFiltersPopup: (state) => {
      state.isMobileFiltersOpened = !state.isMobileFiltersOpened
    }
  },
})

export const { setPopup, changeQuantity, changeMobileFiltersPopup } = popupsSlice.actions

export default popupsSlice.reducer;
